<template>
    <div>
        <multiselect
            :placeholder="$t('select')"
            v-model="selected"
            :disabled="disabled"
            :options="options"
            :class="validateError != '' ? 'box-border-color':''"
            @input="handleInput"
            label="text"
            track-by="value"
            :multiple="false"
            :select-label="''"
            :selected-label="''"
            :deselect-label="''"
            :searchable="true">
            <span slot="noOptions">
                {{ $t('no_options') }}
            </span>
            <span slot="noResult">
                {{ $t('no_result') }}
            </span>
        </multiselect>
        <span class="invalid-feedback-custom"
              v-show="validateError"
              v-html="validateError">
        </span>
    </div>
</template>

<script>
// Helpers
import handleInput from "@/helpers/handleInput";
import setSelected from "@/helpers/setSelected";

// Services
import GradeService from "@/services/GradeService";

// Other
import qs from "qs";

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            default: null
        },
        validateError: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            selected: this.value,
            options: []
        }
    },
    watch: {
        value: function (newValue) {
            this.selected = this.setSelected(newValue, this.options)
        },
    },
    created() {
        this.getOptions();
    },
    methods: {
        handleInput: handleInput,
        setSelected: setSelected,
        getOptions() {
            this.clearOptions()

            const config = {
                params: {
                    limit: -1
                },
            };

            GradeService.getGradeConversions(config)
                .then(response => {
                    const data = response.data.data;
                    data.map(item => {
                        this.options.push({
                            value: item.id,
                            text: item.name,
                        });
                    });
                })
                .then(() => {
                    this.selected = this.setSelected(this.value, this.options)
                })
        },
        clearOptions() {
            this.selected = null;
            this.options = [];
        }
    }
}
</script>
